import { DesktopDatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import moment from 'moment';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router';
import api from '../../../../components/services/api'

export default function ContainerMangement() {
    const [dateStart, setDateStart] = useState(null);
    const [dateEnd, setDateEnd] = useState(null);
    const {id} = useParams()
    const [data, setData] = useState([])
    const getData = async () => {
        try {
          const data = await api.get(`api/stock/detail/stat/${id}`);
          setData(data.data);
        } catch (e) {
          console.log(e);
        }
      };
      useEffect(() => {
        getData()
      },[])
      const getNewData = async () => {
        try {
          const data = await api.get(`api/stock/detail/stat/${id}?startDate=${dateStart ? moment(dateStart).format('yyyy-MM-DD') : ''}&endDate=${dateEnd ? moment(dateEnd).format('yyyy-MM-DD') : ''}`);
          setData(data.data);
        } catch (e) {
          console.log(e);
        }
      };
    return (
        <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>

                <Box
                    style={{ marginTop: "10px",marginBottom:'20px', display: "flex" }}
                >
                    <div style={{ display: "flex" }}>
                        <DesktopDatePicker
                            label="dateStart"
                            inputFormat="yyyy/MM/dd"
                            value={dateStart}
                            // minDate={new Date("2017-01-01")}
                            onChange={async (newValue) => {
                                setDateStart(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField size='small' style={{ width: "60%", marginRight: "10px" }} {...params} />
                            )}
                        />
                        <DesktopDatePicker
                            label="dateEnd"
                            inputFormat="yyyy/MM/dd"
                            value={dateEnd}
                            minDate={new Date(dateStart)}
                            onChange={async (newValue) => {
                                setDateEnd(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField size='small'
                                    style={{ width: "60%", marginRight: "10px" }}
                                    {...params}
                                />
                            )}
                        />

                        <Button variant="contained" onClick={() => {
                            getNewData()
                        }}>Submit</Button>

                    </div>
                </Box>
               

                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell>20' GP</TableCell>
                                    <TableCell>40' HC</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell>Import Container</TableCell>
                                    <TableCell>{data?.ImportContainer?.Size20}</TableCell>
                                    <TableCell>{data?.ImportContainer?.Size40}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Used Container</TableCell>
                                    <TableCell>{data?.UsedContainer?.Size20}</TableCell>
                                    <TableCell>{data?.UsedContainer?.Size40}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>Balance Container</TableCell>
                                    <TableCell>{data?.BalanceContainer?.Size20}</TableCell>
                                    <TableCell>{data?.BalanceContainer?.Size40}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
            </LocalizationProvider>
        </div>
    )
}
